import { FormLabels } from 'components/curo-components/forms/types';

export enum WelcomeFormFields {
  BorrowerPhone = 'BorrowerPhone',
  BorrowerEmail = 'BorrowerEmail',
  BorrowerLast6DigitsSSN = 'BorrowerLast6DigitsSSN',
  BorrowerZipOrPostalCode = 'borrowerZipOrPostalCode',
  TelephoneAndElectronicCommunicationPolicy = 'TelephoneAndElectronicCommunicationPolicy',
}

export interface IWelcomeFormValues {
  [WelcomeFormFields.BorrowerLast6DigitsSSN]: string;
  [WelcomeFormFields.BorrowerEmail]: string;
  [WelcomeFormFields.BorrowerPhone]: string;
  [WelcomeFormFields.BorrowerZipOrPostalCode]: string;
  [WelcomeFormFields.TelephoneAndElectronicCommunicationPolicy]: boolean;
}

export const welcomeFormLabels: FormLabels<WelcomeFormFields> = {
  [WelcomeFormFields.BorrowerEmail]: 'Email',
  [WelcomeFormFields.BorrowerPhone]: 'Cell Phone',
  [WelcomeFormFields.BorrowerLast6DigitsSSN]: 'Last 6 digits of SSN',
  [WelcomeFormFields.BorrowerZipOrPostalCode]: 'Zip Code',
  [WelcomeFormFields.TelephoneAndElectronicCommunicationPolicy]:
    'I agree to Telephone and Electronic Communication Policy',
};
